import DatePicker from "react-datepicker";
import useReadWithGet from "../../hooks/read/useReadWithGetMethod";
import Moment from "react-moment";
import Spinner from "../../components/loader/Spinner";
import Pagination from "../../components/pagination";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
const PunchLogs = () => {
  
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialData = {
    month_year: new Date(),
    pageNo: 0,
    limit: 10
  };

  const { list, paramsObject, setGetListParams } = useReadWithGet({
    url: 'user_check_in_list',
    initialData: initialData,
    onError: (err) => {
      console.log(err);
    }
  })

  useEffect(() => {
    setGetListParams((prev) => {
      return {
        ...prev,
        month_year: searchParams.get('month_year') || new Date(),
        page_number: searchParams.get('pageNo') || 0,
      }
    })
  }, [location]);

  const handleChangeMonth = (value) => {
    let data = {
      ...paramsObject,
      month_year: value
    }
    setGetListParams(data)
    setSearchParams(data)
  }

  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected
    }
    setGetListParams(data)
    //  setSearchParams(data)
  }
  return (
    <div className=" px-5">
      {(list.isLoading || list.isFetching) ? <Spinner /> 
      : <>

        <div className="flex items-center">
          <div className=" lg:basis-[25%] mb-5">
            <label className=" roboto p-2 label">Select Year</label>
            <DatePicker
              name="month_and_year"
              autoComplete="false"
              className="input"
              dateFormat="MM/yyyy"
              maxDate={new Date()}
              selected={new Date(paramsObject?.month_year)}
              showMonthYearPicker
              onChange={handleChangeMonth}
            />
          </div>
        </div>
        <RoundedContainer className="my-6">
          {list?.data?.data?.length ? (
            <div className="max-w-full overflow-x-auto">
              <Table className="table-auto w-full">
                <TableHead>
                  <TableHeaderCell className="w-1/4 text-center">
                    Sr.No
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/2 text-center">
                    Recorded on
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/4 text-center">
                    Approval Status
                  </TableHeaderCell>
                </TableHead>
                <TableBody>
                  {list.data?.data?.map((data, idx) => {
                    const { punch_time, approval_status } = data;
                    const new_punch_time = punch_time * 1000;
                    const srNo =
                      idx + 1 + paramsObject.page_number * paramsObject.limit;
                    return (
                      <TableRow key={idx}>
                        <TableCell className="text-center text-dark font-medium text-sm">
                          {srNo}
                        </TableCell>
                        <TableCell className="text-center text-dark font-medium text-sm">
                          <span className="text-xs bg-gray-200 px-2 py-1 rounded-md">
                            <Moment format="LLL">{new_punch_time}</Moment>
                          </span>
                        </TableCell>
                        <TableCell className="text-center text-dark font-medium text-sm">
                          <span>{approval_status}</span>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          ) : (
            <div className="py-8 text-center font-semibold text-gray-500">
              No Record Found
            </div>
          )}
        </RoundedContainer>

        {list?.data?.total_count > paramsObject?.limit && (
          <RoundedContainer className="my-4">
            <Pagination
              currentPage={+paramsObject.page_number}
              lengthofItems={+list?.data?.total_count}
              limit={+paramsObject.limit}
              onPageChange={handlePageClick}
            />
          </RoundedContainer>
        )}
      </>}
    </div>
  );
};

export { PunchLogs };
